import { UsageService } from '../../../../core/usage/usage.service';
import { schemeCodeOf } from '../../../../core/utils/scheme-code';
import { AfterViewInit, Component, Inject, OnInit, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { now } from 'lodash';
import { combineLatest, EMPTY, forkJoin, of, switchMap, takeUntil, tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { MedpraxService } from 'src/app/core/invoicing/medprax.invoicing.service';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import { PatientFinancalBillingService } from 'src/app/core/services/patient-financal-billing.service';
import { PatientFinancialService } from 'src/app/core/services/patient-financial.service';
import { PatientService } from 'src/app/core/services/patient.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { GroupService } from 'src/app/core/services/group.service';
import { PatientCommunicationService } from 'src/app/core/services/patient-communication.service';
import { PatientAppointmentService } from 'src/app/core/services/patient-appointment.service';
import * as _ from 'lodash';
import { MultilineItemsComponent } from './multiline-items/multiline-items.component';
import { UserService } from 'src/app/core/services/user.service';
import { CapturePaymentComponent } from './capture-payment/capture-payment.component';
import { InvoiceComponent } from '../patient-invoicing-list/patient-invoicing-list.component';
import { HospitalService } from 'src/app/core/services/hospital.service';
import { FormUtils } from 'src/app/core/utils/form.utils';
import { PatientBillingService } from 'src/app/core/services/patient-billing.service';
import { AppDataService } from 'src/app/core/services/app-data.service';
import { SPECIALITIES } from 'src/app/core/data/app.data';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { ThemeService } from 'src/app/core/services/theme.service';
import { PatientAiService } from 'src/app/core/services/patient-ai.service';
import { FileDownloadService } from 'src/app/core/services/file-download.service';
import { PatientCreditService } from 'src/app/core/services/patient-credit.service';
// import { InvoiceComponent } from '../patient-invoicing/patient-invoicing.component';


@Component({
  selector: 'app-dispute-form',
  templateUrl: './dispute-form.component.html',
  styleUrls: ['./dispute-form.component.scss']
})
export class DisputeFormComponent extends BaseComponent implements OnInit {
  /** Marks where this work starts or finishes, for REMOAT's usage report. */
  private readonly usage = inject(UsageService);
  tariffs: any[] = [];
  nappiProducts: any[] = [];
  form!: FormGroup;
  patient: any = {};
  groupUsers: any[] = [];
  hospitals: any[] = [];
  isLoading = false;
  selectedAppointment: string = '';
  selectedStatus: string = '';
  selectedQuotes: string = '';
  group!: any;
  appointments!: any[] | null;
  aiRequests!: any[] | null;
  emails?: any[] | null = [];
  tariffRates: any[] = [];
  editingTariffs: any[] = [];
  selectedPriceGroup: string = '';
  currentUser: any;
  billingType: string = '';
  billingCode: any;
  selectedTariffRateType: string = 'networkRate';
  icdCodesArray: FormArray = this.fb.array([]);
  showMultilineItems: boolean = false;
  discountType: 'percentage' | 'fixed' = 'percentage';
  sections = {
    billingInfo: true,
    billingDetails: true,
    lineItems: true,
    summary: true
  };

  patientProcedureCodes: any[] = [];
  isPhysioPractice: boolean = false;
  @ViewChild(MultilineItemsComponent) multilineItemsComponent!: MultilineItemsComponent;

  // Trigger for multiline items component updates
  multilineItemsTrigger: number = 0;

  darkTheme!: NgxMaterialTimepickerTheme;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private medpraxService: MedpraxService,
    private router: Router,
    private patientFinancalBillingService: PatientFinancalBillingService,
    private patientFinancialService: PatientFinancialService,
    private patientService: PatientService,
    private groupService: GroupService,
    private patientCodingService: PatientBillingService,
    // private multilineItemsComponent: MultilineItemsComponent,
    private patientCommunicationService: PatientCommunicationService,
    private patientAppointmentService: PatientAppointmentService,
    public dialogRef: MatDialogRef<DisputeFormComponent>,
    private userService: UserService,
    private hospitalService: HospitalService,
    private appDataService: AppDataService,
    private themeService: ThemeService,
    private patientAIService: PatientAiService,
    private cdr: ChangeDetectorRef,
    private fileDownloadService: FileDownloadService,
    private patientCreditService: PatientCreditService,
    fs: FeedbackService,
    md: MatDialog,
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
    this.usage.flow('invoice or estimate', 'start');
    this.initForm();
    this.billingCode = this.patientFinancalBillingService.createUniqueCode();

    // subscribe to the current patient AND the current group so we can calcualte the default rate for the patients scheme
    combineLatest([
      this.patientService.currentPatient$,
      this.groupService.selectedGroup$
    ]).pipe(
      takeUntil(this.destroy$),
      switchMap(([patient, group]) => {
        console.log("Patient: ", patient);
        console.log("Group: ", group);
        if (patient && group) {
          this.patient = patient;
          this.group = group;
          if (group.groupSpeciality === 'Physiotherapy') {
            this.isPhysioPractice = true;
          }
          this.form.patchValue({ patientId: this.patient.id, groupId: this.group.id });
          return of([patient, group]);
        }
        return EMPTY;
      }),
      // link into the flow to load the group tariff rates
      switchMap(([patient, group]) => {
        console.log("Patient: ", patient);
        console.log("Group: ", group);
        return this.medpraxService.getTariffRatesByGroup(group.id);
      })
    ).subscribe(
      (response) => {
        console.log("Response: ", response);
        this.tariffRates = response.tariffRates;
        console.log("✅ Tariff Rates Fetched:", this.tariffRates);
        if (this.tariffRates.length > 0) {
          if (!this.patient.medicalAid || this.patient.medicalAid === 'Private Patient') {
            // use the rate with the highest modifier for private patients
            const highestModifierRate = this.tariffRates.sort((a, b) => b.modifier - a.modifier)[0];
            this.form.patchValue({ priceGroup: highestModifierRate.id });
            this.selectedTariffRateType = highestModifierRate.id;
            this.selectedPriceGroup = highestModifierRate.id;
          } else {
            // try find a rate the matches the patients medicalSchemeCode
            const matchingRate = this.tariffRates.find(rate => rate.priceGroupCode === schemeCodeOf(this.patient.medicalSchemeCode));
            if (matchingRate) {
              this.form.patchValue({ priceGroup: matchingRate.id });
              this.selectedTariffRateType = matchingRate.id;
              this.selectedPriceGroup = matchingRate.id;
            } else {
              // use the default rate
              const defaultRate = this.tariffRates.find(rate => rate.isDefaultRate);
              if (defaultRate) {
                this.form.patchValue({ priceGroup: defaultRate.id });
                this.selectedTariffRateType = defaultRate.id;
                this.selectedPriceGroup = defaultRate.id;
              } else {
                // fallback to a default rate that we define that will use the patients medical scheme rate as a base without a modifier (modifer = 100%)
                const fallbackRate = {
                  id: 'fallback',
                  groupId: this.group.id,
                  name: 'Patient Scheme Rate',
                  priceGroup: {
                    code: schemeCodeOf(this.patient.medicalSchemeCode),
                    description: '',
                    tariffMedicalTypeCode: 'MP',
                    tariffMedicalType: { code: 'MP', description: 'MP' }
                  },
                  modifier: 100,
                  isDefaultRate: true,
                  isNetworkDoctor: false,
                  active: true,
                  createdAt: new Date(),
                  updatedAt: new Date()
                }
                this.tariffRates.push(fallbackRate);
                this.form.patchValue({ priceGroup: fallbackRate.id });
                this.selectedTariffRateType = fallbackRate.id;
                this.selectedPriceGroup = fallbackRate.id;
              }
            }
          }
        }

        // Handle prefill data if provided (after tariff rates are loaded)
        if (this.data.prefillData) {
          console.log('Handling prefill data after tariff rates loaded');
          this.prefillForm(this.data.prefillData);
        }
      }
    );

    this.groupService.groupUsers$
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any[]) => {
        if (users?.length) {
          this.groupUsers = users?.filter(u => u.userType === 'doctor' && u.userId !== '511f39e1-ff14-4a6d-b35a-6fcc22923b50');
          this.determineProviderSelection();
        }
      });

    this.hospitalService.hospitals$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hospitals => {
        this.hospitals = hospitals;
      });

    combineLatest([this.patientAppointmentService.patientAppointments$, this.patientAIService.patientAIRequests$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([appointments, aiRequests]: any) => {
        if (!appointments || appointments.length === 0) {
          this.appointments = []; // Ensure it's always an array
          return;
        }

        this.aiRequests = aiRequests;
        // Format and sort appointments by date (descending order)
        this.appointments = _.orderBy(
          appointments.map((appointment: any) => ({
            ...appointment,
            formattedDate: moment(appointment.date).format('YYYY-MM-DD') // Format date here
          })),
          ['formattedDate'], // Sort by formatted date
          ['desc'] // Descending order
        );

        console.log("Appointments: ", this.appointments);

      });

    this.patientCodingService.patientBilling$
      .pipe(takeUntil(this.destroy$))
      .subscribe((billing: any[] | null) => {
        this.patientProcedureCodes = this.groupAndSortTariffCodes(billing) || [];
      });

    this.form.get('discount')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((discountValue) => {
        this.medpraxService.updateDiscount(discountValue);
      });

    this.userService.userProfile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.currentUser = result;
      });

    this.themeService.isDarkMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDarkMode) => {
        this.darkTheme = this.themeService.getTimepickerTheme(isDarkMode);
      });

  }

  private groupAndSortTariffCodes(codes: any[] | null): any[] | null {
    if (!codes || !codes.length) {
      return codes;
    }

    const grouped = _.groupBy(codes, code => moment(code.date).format('YYYY-MM-DD'));

    return _.chain(grouped)
      .map((value, key) => {
        const combinedCodes = value.map(item => ({
          id: item.id,
          code: item.code,
          description: item.description,
          paidCash: item.paidCash,
          noCharge: item.noCharge,
        }));
        return {
          date: key,
          codes: combinedCodes,
          codeList: combinedCodes.map(c => { return c.code + `${c.paidCash ? ' (Paid Up Front)' : ''}${c.noCharge ? ' (Pro Bono)' : ''}` }).join(', ')
        };
      })
      .orderBy(group => group.date, 'desc')
      .value();
  }

  private findCodesForAppointmentDate(date: string): any[] {
    return this.patientProcedureCodes.find(code => code.date === date)?.codes || [];
  }

  /**
   * Determines the provider selection logic based on the user's requirements:
   * - If only one provider in the group, use that as default and don't show selection
   * - If multiple providers and logged-in user is a physician, default to them
   * - Otherwise (multiple providers and logged-in user is not a physician), default to group owner and show dropdown
   */
  private determineProviderSelection(): void {
    if (this.groupUsers.length === 0) {
      this.form.patchValue({ provider: null });
      return;
    }

    if (this.groupUsers.length === 1) {
      // Only one provider - use as default
      this.form.patchValue({ provider: this.groupUsers[0].userId });
      return;
    }

    // Multiple providers - check if current user is a physician
    const currentUser = this.userService.user;
    const isCurrentUserPhysician = this.userService.isUserPhysician;

    if (isCurrentUserPhysician) {
      // Current user is a physician - default to them
      this.form.patchValue({ provider: currentUser.id });
    } else {
      // Current user is not a physician - default to group owner
      const groupOwner = this.groupUsers.find(user => user.userId === this.groupService.group?.ownerId) || this.groupUsers[0];
      this.form.patchValue({ provider: groupOwner?.userId || null });
    }
  }

  updateDiscount() {
    setTimeout(() => {
      const discountValue = this.form.get('discount')?.value;
      const discountType = this.form.get('discountType')?.value;
      this.medpraxService.updateDiscount(discountValue, discountType);
    }, 0);
  }

  getBillingType(): boolean {
    return this.form.get('type')?.value != 'Invoice';
  }

  // Calculate Price for Tariff Code
  calculateTariffPrice(tariff: any): number {
    const basePrice = tariff.tariffRandCalculated || tariff.tariffRatePublished || 0;
    const units = tariff.numberOfUnits || 1;
    const markupMatch = tariff.extraInfo?.match(/(\d+)%/);
    const markupMultiplier = markupMatch ? parseFloat(markupMatch[1]) / 100 : 1;
    return (basePrice * units * markupMultiplier).toFixed(2) as unknown as number;
  }

  // Calculate Price for NAPPI Code
  calculateNappiPrice(product: any): number {
    const singleExitPrice = product.singleExitPrice || 0;
    const standardPackSize = product.standardPacksize || 1;
    const dispensingVolume = product.dispensingVolumePacksize || standardPackSize;
    const pricePerUnit = singleExitPrice / standardPackSize;
    return (pricePerUnit * dispensingVolume).toFixed(2) as unknown as number;
  }

  returnToParent() {
    this.router.navigate(['/patients', { outlets: { patient: ['file', `${this.patient.id}`] } }]);
  }

  initForm() {
    this.form = this.fb.group({
      type: ['Invoice', Validators.required],
      appointment: ['', Validators.required],
      status: ['Pending'],
      provider: ['', Validators.required],
      issueDate: [new Date(), Validators.required],
      dueDate: [new Date(), Validators.required],
      priceGroup: ['', Validators.required],
      discount: [0],
      discountType: ['percentage'],
      notes: [''],
      lineItems: this.fb.array([]),
      ruleType: ['OH', Validators.required], // Default to Out of Hospital
      isInHospital: [false],
      hospital: [''],
      modifierType: ['practice'],
      startTime: [''],
      finishTime: [''],
      vatExclusive: [false],
    });

    FormUtils.showFormErrorStates(this.form);

    this.form.get('appointment')?.valueChanges.subscribe(async (value) => {
      if (value) {
        const codes = this.findCodesForAppointmentDate(value.formattedDate);
        if (codes.length > 0) {
          const confirmed = await this.feedbackService.showConfirmation('Tariff Codes Detected', `We detected ${codes.length} tariff codes for this appointment date. Would you like to add these codes to the ${this.form.get('type')?.value}? \n\n ${codes.reduce((acc, curr) => acc + '- ' + curr.code + ': ' + curr.description.slice(0, 80) + '...\n\n', '')}`, undefined, 'No', 'Yes');
          if (confirmed) {
            const procedureCodes: any[] = [];
            codes.forEach(code => {
              const directLookup = this.appDataService.performDirectLookup(code.code, 'pc', this.group?.groupSpeciality);
              procedureCodes.push(directLookup);
            });
            // Pass the appointment date to use for the line items
            const appointmentDate = new Date(value.date);
            this.multilineItemsComponent.handleCodingBundleSelection({ procedureCodes }, appointmentDate);
          }
        }

        this.findTimesForAppointment(value);
      }
    });

  }

  findTimesForAppointment(appointment: any) {
    if (!this.isPhysioPractice) return;

    let aiRequest = this.aiRequests?.find(request => moment(request.createdAt).isSame(moment(appointment.date), 'day'));
    if (!aiRequest) {
      aiRequest = this.aiRequests?.find(request => moment(request.createdAt).isSame(moment(appointment.date).add(1, 'day'), 'day'));
    }
    if (aiRequest) {
      this.form.patchValue({ startTime: aiRequest.startTime, finishTime: aiRequest.finishTime });
    }
  }

  // Add properties for financial summary
  overallSubtotal: number = 0;
  overallVat: number = 0;
  overallVatRate: number = 0;
  overallTotalDue: number = 0;
  overallShortfall: number = 0;
  //Generate invoice and quote, and the preview of the the data
  async saveForm() {
    // Form validation
    if (this.form.invalid) {
      console.warn("Form is invalid. Please check required fields.");
      this.showToastMessage('Please complete all required fields before proceeding');
      this.form.updateValueAndValidity();
      return;
    }
    const appointment = this.form.get('appointment')?.value;
    if (appointment) {
      const appointmentDate = moment(appointment.date);
      const issueDate = moment(this.form.get('issueDate')?.value);
      if (!appointmentDate.isSame(issueDate, 'day')) {

        const confirmed = await this.feedbackService
          .showConfirmation(
            'Appointment Date Mismatch',
            'The appointment date does not match the issue date. Would you like to update the issue date to the appointment date?',
            undefined,
            'No',
            'Yes');

        if (confirmed) {
          this.form.get('issueDate')?.setValue(appointmentDate.toDate());
        }
      }
    }

    this.isLoading = true;

    const formValues = this.form?.value;
    const billingItems = formValues?.lineItems || [];
    const selectedStatus = this.form.get('status')?.value;

    // Calculate totals using the new format
    let subtotalIncl = 0;
    const lineItems = this.lineItems.controls.map(control => {
      const value = control.value;
      const itemTotal = parseFloat(value.balance || 0);
      subtotalIncl += itemTotal;

      return {
        description: value.description,
        quantity: value.quantity || 1,
        unitPrice: value.unitPrice || 0,
        totalAmount: itemTotal,
        code: value.code, // This is the required field for the backend
        quantityUnit: value.quantityUnit, // Include quantity unit for PDF display
        codeType: value.codeType || 'procedure',
        tariffCode: value.code, // Keep for compatibility
        tariffDescription: value.description,
        nappiCode: value.nappiCode,
        nappiDescription: value.nappiDescription,
        icdCodes: value.icdCodes || [],
        hospitalId: value.hospitalId,
        hospitalName: value.hospitalName,
        hospitalSetting: value.hospitalSetting,
        ruleType: value.ruleType,
        ruleTypeDescription: value.ruleTypeDescription,
        modifier: value.modifier,
        modifierDescription: value.modifierDescription,
        discountType: value.discountType || 'percentage',
        discountAmount: value.discountAmount || 0,
        discountPercentage: value.discountPercentage || 0,
        vatAmount: value.vatAmount || 0,
        vatPercentage: value.vatPercentage || 15,
        totalAfterDiscount: value.totalAfterDiscount || itemTotal,
        totalAfterVat: value.totalAfterVat || itemTotal,
        date: value.date || new Date(),
        startTime: value.startTime || formValues.startTime || '',
        endTime: value.endTime || formValues.finishTime || '',
        assistantName: value.assistantName || '',
        assistantPracticeNumber: value.assistantPracticeNumber || '',
        // Add missing fields that are being stripped
        modifiers: value.modifiers || [],
        units: value.units || 0,
        ruleTypeOverride: value.ruleTypeOverride || null,
        providerId: value.providerId || null,
        trace: value.trace || [],
        ruleSuggestions: value.ruleSuggestions || [],
        isModifierLine: value.isModifierLine || false,
        weight: value.weight || '',
        height: value.height || '',
        BMI: value.BMI || '',
        initialRand: value.initialRand || 0,
        initialUnits: value.initialUnits || 0,
        cusPrice: value.cusPrice || 0,
        displayIndex: value.displayIndex || 0
      };
    });


    const vat = this.overallVat;
    const vatRate = this.overallVatRate;
    const subtotalExcl = this.overallSubtotal;
    const totalDue = this.overallTotalDue;

    // Determine document type based on form type
    const documentType = this.form.get('type')?.value === 'Estimate' ? 'estimate' : 'invoice';

    // Prepare data for new service
    const billingData = {
      patientId: this.patient?.id,
      groupId: this.group.id,
      providerId: this.form.get('provider')?.value,
      priceGroupId: this.form.get('priceGroup')?.value,
      documentType: documentType as 'estimate' | 'invoice' | 'receipt' | 'statement',
      billingDate: this.form.get('issueDate')?.value,
      issueDate: this.form.get('issueDate')?.value,
      dueDate: this.form.get('dueDate')?.value,
      appointmentId: this.form.get('appointment')?.value?.id || undefined,
      subtotal: subtotalExcl,
      vatAmount: vat,
      totalAmount: totalDue,
      shortfallAmount: 0, // Will be calculated by the service
      discountType: this.form.get('discountType')?.value || 'percentage',
      discountAmount: this.form.get('discount')?.value || 0,
      discountPercentage: this.form.get('discount')?.value || 0,
      notes: this.form.get('notes')?.value,
      lineItems: lineItems,
      vatExclusive: this.form.get('vatExclusive')?.value === true,
      vatRate: vatRate,
    };

    // First, save the billing document using the new service
    this.patientFinancialService.createBillingDocument(billingData).subscribe({
      next: (result: any) => {
        const savedDocument = result.data;
        console.log('Billing document saved successfully:', savedDocument);
        this.usage.flow('invoice or estimate', 'done');
        this.usage.action(documentType === 'estimate' ? 'Estimate created' : 'Invoice created');

        // Now generate PDF using the old service for compatibility
        const currentGroup = this.groupService.group;
        const plainUser = {
          title: this.currentUser?.title,
          name: this.currentUser?.name,
          surname: this.currentUser?.surname,
        };

        const pdfBillingData = {
          patientId: this.patient?.id,
          type: this.form.get('type')?.value,
          appointment: this.form.get('appointment')?.value,
          status: selectedStatus,
          issueDate: this.form.get('issueDate')?.value,
          dueDate: this.form.get('dueDate')?.value,
          priceGroup: this.form.get('priceGroup')?.value,
          discount: this.form.get('discount')?.value,
          discountType: this.form.get('discountType')?.value,
          notes: this.form.get('notes')?.value,
          lineItems: lineItems,
          ruleType: this.form.get('ruleType')?.value,
          totalDue: totalDue.toFixed(2) || 0,
          patient: this.patient,
          group: currentGroup,
          user: plainUser,
          billingNumber: savedDocument.billingNumber, // Use the generated billing number
          provider: this.groupUsers.find(u => u.userId === this.form.get('provider')?.value),
          providers: this.groupUsers,
          hospital: this.form.get('hospital')?.value,
          vatExclusive: this.form.get('vatExclusive')?.value === true,
          vatRate: savedDocument.vatRate ?? vatRate,
          practiceInfo: {
            practiceName: this.group.companyName || this.group.name,
            practiceNumber: this.group.practiceNumber,
            email: this.group.practiceEmail,
            tel: this.group.practicePhone,
          }
        };

        // Generate and download PDF
        this.patientFinancalBillingService.generateBillingPDF(savedDocument.id, pdfBillingData)
          .then((pdfBytes) => {
            // Convert PDF bytes to blob
            const pdfBlob = new Blob([pdfBytes as any], { type: 'application/pdf' });
            const fileName = `${pdfBillingData.type}-${this.patient.name}-${this.patient.surname}_${Date.now()}.pdf`;

            // Upload PDF to the new service
            this.patientFinancialService.uploadBillingDocumentPDF(savedDocument.id, this.group.id, pdfBlob, fileName)
              .subscribe({
                next: (updatedDocument) => {
                  this.isLoading = false;
                  console.log('PDF uploaded successfully:', updatedDocument);

                  // Trigger a platform-aware download
                  void this.fileDownloadService.download(pdfBlob, fileName);

                  this.showToastMessage(`${pdfBillingData.type} saved and PDF uploaded successfully`);

                  // Check if status requires payment capture
                  const shouldCapturePayment = selectedStatus === 'Paid' || selectedStatus === 'Partially Paid';

                  // Close dialog if not capturing payment
                  if (!shouldCapturePayment) {
                    this.dialogRef.close({ success: true, billingDocument: updatedDocument });
                    // A new invoice for a patient with credit on account: offer to pay it from the credit.
                    if (documentType === 'invoice') {
                      void this.patientCreditService.offer(savedDocument, this.group);
                    }
                  } else {
                    this.handleNewPaymentCapture(updatedDocument);
                  }
                },
                error: (uploadError) => {
                  this.isLoading = false;
                  console.error('Error uploading PDF:', uploadError);
                  this.showToastMessage('Document saved but error uploading PDF. Please try again.');
                }
              });
          })
          .catch((error) => {
            this.isLoading = false;
            console.error('Error generating PDF:', error);
            this.showToastMessage('Document saved but error generating PDF. Please try again.');
          });
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error saving billing document:', error);
        this.showToastMessage('Failed to save billing document: ' + error.message);
      }
    });
  }

  // Preview the form by generating PDF without saving to database
  previewForm() {
    // Form validation
    if (this.form.invalid) {
      console.warn("Form is invalid. Please check required fields.");
      this.showToastMessage('Please complete all required fields before proceeding');
      this.form.updateValueAndValidity();
      return;
    }

    this.isLoading = true;

    const formValues = this.form?.value;
    const billingItems = formValues?.lineItems || [];
    const selectedStatus = this.form.get('status')?.value;

    // Calculate totals using the new format
    let subtotalIncl = 0;
    const lineItems = this.lineItems.controls.map(control => {
      const value = control.value;
      const itemTotal = parseFloat(value.balance || 0);
      subtotalIncl += itemTotal;

      return {
        description: value.description,
        quantity: value.quantity || 1,
        unitPrice: value.unitPrice || 0,
        totalAmount: itemTotal,
        code: value.code,
        quantityUnit: value.quantityUnit, // Include quantity unit for PDF display
        codeType: value.codeType || 'procedure',
        tariffCode: value.code,
        tariffDescription: value.description,
        nappiCode: value.nappiCode,
        nappiDescription: value.nappiDescription,
        icdCodes: value.icdCodes || [],
        hospitalId: value.hospitalId,
        hospitalName: value.hospitalName,
        hospitalSetting: value.hospitalSetting,
        ruleType: value.ruleType,
        ruleTypeDescription: value.ruleTypeDescription,
        modifier: value.modifier,
        modifierDescription: value.modifierDescription,
        discountType: value.discountType || 'percentage',
        discountAmount: value.discountAmount || 0,
        discountPercentage: value.discountPercentage || 0,
        vatAmount: value.vatAmount || 0,
        vatPercentage: value.vatPercentage || 15,
        totalAfterDiscount: value.totalAfterDiscount || itemTotal,
        totalAfterVat: value.totalAfterVat || itemTotal,
        date: value.date || new Date(),
        startTime: value.startTime || formValues.startTime || '',
        endTime: value.endTime || formValues.finishTime || '',
        assistantName: value.assistantName || '',
        assistantPracticeNumber: value.assistantPracticeNumber || '',
        // Add missing fields that are being stripped
        modifiers: value.modifiers || [],
        units: value.units || 0,
        ruleTypeOverride: value.ruleTypeOverride || null,
        providerId: value.providerId || null,
        trace: value.trace || [],
        ruleSuggestions: value.ruleSuggestions || [],
        isModifierLine: value.isModifierLine || false,
        weight: value.weight || '',
        height: value.height || '',
        BMI: value.BMI || '',
        initialRand: value.initialRand || 0,
        initialUnits: value.initialUnits || 0,
        cusPrice: value.cusPrice || 0,
        displayIndex: value.displayIndex || 0
      };
    });

    const vat = this.overallVat;
    const subtotalExcl = this.overallSubtotal;
    const totalDue = this.overallTotalDue;

    // Get current group and user info
    const currentGroup = this.groupService.group;
    const plainUser = {
      title: this.currentUser?.title,
      name: this.currentUser?.name,
      surname: this.currentUser?.surname,
    };

    // Prepare data for PDF generation (without saving to database)
    const pdfBillingData = {
      patientId: this.patient?.id,
      type: this.form.get('type')?.value,
      appointment: this.form.get('appointment')?.value,
      status: selectedStatus,
      issueDate: this.form.get('issueDate')?.value,
      dueDate: this.form.get('dueDate')?.value,
      priceGroup: this.form.get('priceGroup')?.value,
      discount: this.form.get('discount')?.value,
      discountType: this.form.get('discountType')?.value,
      notes: this.form.get('notes')?.value,
      lineItems: lineItems,
      ruleType: this.form.get('ruleType')?.value,
      totalDue: totalDue.toFixed(2) || 0,
      patient: this.patient,
      group: currentGroup,
      user: plainUser,
      billingNumber: `PREVIEW-${Date.now()}`, // Generate a temporary billing number
      provider: this.groupUsers.find(u => u.userId === this.form.get('provider')?.value),
      providers: this.groupUsers,
      hospital: this.form.get('hospital')?.value,
      vatExclusive: this.form.get('vatExclusive')?.value === true,
      vatRate: this.overallVatRate,
      practiceInfo: {
        practiceName: this.group.companyName || this.group.name,
        practiceNumber: this.group.practiceNumber,
        email: this.group.practiceEmail,
        tel: this.group.practicePhone,
      }
    };

    // Generate PDF using a temporary ID
    const tempId = `preview-${Date.now()}`;
    this.patientFinancalBillingService.generateBillingPDF(tempId, pdfBillingData)
      .then((pdfBytes) => {
        // Convert PDF bytes to blob
        const pdfBlob = new Blob([pdfBytes as any], { type: 'application/pdf' });
        const fileName = `PREVIEW-${pdfBillingData.type}-${this.patient.name}-${this.patient.surname}_${Date.now()}.pdf`;

        // Trigger a platform-aware download
        void this.fileDownloadService.download(pdfBlob, fileName);

        this.isLoading = false;
        this.showToastMessage(`PDF preview generated successfully: ${fileName}`);
      })
      .catch((error) => {
        this.isLoading = false;
        console.error('Error generating PDF preview:', error);
        this.showToastMessage('Error generating PDF preview. Please try again.');
      });
  }

  onTariffChange(event: any) {
    const selectedRate = this.tariffRates.find(rate => rate.id === event.value);
    this.selectedPriceGroup = selectedRate ? selectedRate.id : '';
    // Show multiline items when a price group is selected
    this.showMultilineItems = true;
    this.form.patchValue({ priceGroup: this.selectedPriceGroup });
    console.log("✅ Selected Price Group:", this.selectedPriceGroup);
  }

  // New method to handle payment capture with the new service
  private handleNewPaymentCapture(billingData: any): void {
    const dialogRef = this.dialog.open(CapturePaymentComponent, {
      width: '600px',
      //height: '80vh',
      data: {
        patientId: this.patient.id,
        groupId: this.group.id,
        patient: this.patient,
        patientName: this.patient.firstName + ' ' + this.patient.lastName,
        group: this.groupService.group,
        invoiceId: billingData.id,
        billingNumber: billingData.billingNumber,
        totalDue: billingData.totalAmount,
        //isActive: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        console.log('Payment captured successfully:', result.payment);
        this.dialogRef.close({
          success: true,
          billingDocument: billingData,
          payment: result.payment
        });
      } else if (result && !result.success) {
        console.error('Payment capture failed:', result.error);
        this.showToastMessage(result.error || 'Payment capture failed');
      }
    });
  }

  get lineItems(): FormArray {
    return this.form.get('lineItems') as FormArray;
  }

  createLineItem(): FormGroup {

    return this.fb.group({
      date: [new Date(), Validators.required],
      icd10: this.icdCodesArray.value,
      code: ['', Validators.required],
      description: ['', Validators.required],
      codeType: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.min(0.01)]],
      quantityUnit: [null],
      cusPrice: [0, [Validators.required, Validators.min(0)]],
      // rateType: [this.selectedTariffRateType, Validators.required],
      unitPrice: [0, [Validators.required, Validators.min(0)]],
      balance: [0],
      discount: [0, [Validators.max(100), Validators.min(0)]],
      discountType: ['percentage'],
      ruleTypeOverride: [null],
      icdCodes: [[]],
      units: [0],
      modifiers: [[]],
      isModifierLine: [false],
      trace: [[]],
      ruleSuggestions: [[]],
      startTime: [''],
      endTime: [''],
      assistantName: [''],
      assistantPracticeNumber: [''],
      weight: [''],
      height: [''],
      BMI: [''],
      initialRand: [0],
      initialUnits: [0],
      displayIndex: [this.lineItems.length], // Add displayIndex for ordering
    });
  }

  isQuote(): boolean {
    const type = this.form.get('type')?.value == 'Estimate';
    if (type) {
      this.form.get('status')?.setValue('Pending');
    }
    return type;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  toggleDiscountType() {
    const currentType = this.form.get('discountType')?.value;
    const newType = currentType === 'percentage' ? 'fixed' : 'percentage';
    this.form.patchValue({ discountType: newType });
    this.updateDiscount();
  }

  onHospitalSettingChange() {
    // Get the multiline items component
    const multilineItems = this.multilineItemsComponent;
    if (multilineItems) {
      // Recalculate prices for all line items
      multilineItems.lineItems.controls.forEach((control, index) => {
        const code = control.get('code')?.value;
        const codeType = control.get('codeType')?.value;

        if (code && codeType) {
          // Re-fetch prices for the code
          multilineItems.handleCodeSelection({ code, type: codeType }, codeType, index);
        }
      });
    }
  }

  updateTotals(totals: any) {
    /* subtotal: Number(this.overallSubtotal.toFixed(2)),
    vat: Number(this.overallVat.toFixed(2)),
    totalDue: Number(this.overallTotalDue.toFixed(2)),
    shortfall: Number(this.overallShortfall.toFixed(2)) */

    this.overallSubtotal = parseFloat(totals.subtotal.toFixed(2));
    this.overallShortfall = parseFloat(totals.shortfall.toFixed(2));
    this.overallVat = parseFloat(totals.vat.toFixed(2));
    this.overallVatRate = Number(totals.vatRate) || 0;
    this.overallTotalDue = parseFloat(totals.totalDue.toFixed(2));
    this.form.patchValue({
      totalExclVat: this.overallSubtotal,
      totalVat: this.overallVat,
      totalInclVat: this.overallTotalDue
    });
  }

  async onRuleTypeChange() {
    const lineItems = this.form.get('lineItems')?.value;
    if (!lineItems?.length) return;

    // Check if any line items have custom rule type overrides
    const hasOverrides = lineItems.some((item: any) => item.ruleTypeOverride);

    if (hasOverrides) {
      const confirmed = await this.feedbackService.showConfirmation(
        'Update Rule Types',
        'Changing the default rule type will affect all line items. Do you want to update all line items to use the new default rule type?',
        undefined,
        'Keep Overrides',
        'Update All'
      );

      if (!confirmed) {
        // Revert the rule type change
        this.form.patchValue({ ruleType: this.form.get('ruleType')?.value });
        return;
      }
    }

    // Update prices for all line items
    const multilineItems = this.multilineItemsComponent;
    if (multilineItems) {
      const lineItemsArray = this.form.get('lineItems') as FormArray;
      for (let i = 0; i < lineItemsArray.length; i++) {
        const lineItem = lineItemsArray.at(i);
        const code = lineItem.get('code')?.value;
        const codeType = lineItem.get('codeType')?.value;

        if (code && codeType) {
          // Reset any overrides if confirmed
          if (hasOverrides) {
            lineItem.patchValue({ ruleTypeOverride: null });
          }
          await multilineItems.handleCodeSelection({ code, type: codeType }, codeType, i);
        }
      }
    }
  }

  toggleSection(section: 'billingInfo' | 'billingDetails' | 'lineItems' | 'summary'): void {
    this.sections[section] = !this.sections[section];
  }

  private prefillForm(prefillData: any): void {
    // Prefill basic form fields
    this.form.patchValue({
      type: prefillData.type || 'Invoice',
      appointment: prefillData.appointment || '',
      status: prefillData.status || 'Pending',
      issueDate: prefillData.issueDate || new Date(),
      dueDate: prefillData.dueDate || new Date(),
      discount: prefillData.discount || 0,
      discountType: prefillData.discountType || 'percentage',
      notes: prefillData.notes || '',
      ruleType: prefillData.ruleType || 'OH',
      hospital: prefillData.hospital || '',
      startTime: prefillData.startTime || '',
      finishTime: prefillData.finishTime || '',
      vatExclusive: prefillData.vatExclusive === true,
    });

    // Handle price group separately to ensure tariff rates are available
    if (prefillData.priceGroup) {
      // Check if the price group exists in the loaded tariff rates
      const matchingRate = this.tariffRates.find(rate => rate.id === prefillData.priceGroup);
      if (matchingRate) {
        this.form.patchValue({ priceGroup: prefillData.priceGroup });
        this.selectedPriceGroup = prefillData.priceGroup;
        this.selectedTariffRateType = prefillData.priceGroup;
        console.log("✅ Using prefill price group:", prefillData.priceGroup);
      } else {
        console.warn("⚠️ Prefill price group not found in tariff rates:", prefillData.priceGroup);
        console.log("Available tariff rates:", this.tariffRates.map(r => r.id));
      }
    }

    // Prefill line items if provided
    if (prefillData.lineItems && prefillData.lineItems.length > 0) {
      // Clear existing line items
      while (this.lineItems.length !== 0) {
        this.lineItems.removeAt(0);
      }

      // Add prefill line items
      console.log('Adding prefill line items:', prefillData.lineItems.length);
      prefillData.lineItems.forEach((item: any, index: number) => {
        const lineItem = this.createLineItem();
        
        // For consumables, detect if code has "0201 - " prefix and set checkbox accordingly
        const isConsumable = item.codeType === 'consumable';
        const has0201Prefix = isConsumable && item.code && item.code.startsWith('0201 - ');
        const include0201Code = isConsumable ? (has0201Prefix || item.include0201Code !== false) : true;
        
        lineItem.patchValue({
          date: item.date ? new Date(item.date) : new Date(),
          code: item.code || '',
          description: item.description || '',
          codeType: item.codeType || 'procedure',
          quantity: item.quantity || 1,
          quantityUnit: item.quantityUnit || null,
          unitPrice: item.unitPrice || 0,
          balance: item.totalAmount || item.balance || 0,
          discount: item.discountAmount || item.discount || 0,
          discountType: item.discountType || 'percentage',
          ruleTypeOverride: item.ruleTypeOverride || null,
          providerId: item.providerId || null,
          icdCodes: item.icdCodes || [],
          units: item.units || 0,
          modifiers: item.modifiers || [],
          isModifierLine: item.isModifierLine || false,
          trace: item.trace || [],
          ruleSuggestions: item.ruleSuggestions || [],
          startTime: item.startTime || '',
          endTime: item.endTime || '',
          assistantName: item.assistantName || '',
          assistantPracticeNumber: item.assistantPracticeNumber || '',
          weight: item.weight || '',
          height: item.height || '',
          BMI: item.BMI || '',
          initialRand: item.initialRand || 0,
          initialUnits: item.initialUnits || 0,
          displayIndex: index,
          include0201Code: include0201Code
        });
        this.lineItems.push(lineItem);
        console.log(`Added line item ${index + 1}:`, item.code, item.description);
      });

      console.log('Total line items after prefill:', this.lineItems.length);

      // Show multiline items section
      this.showMultilineItems = true;
      this.sections.lineItems = true;

      // Trigger multiline items component update with a delay to ensure proper initialization
      setTimeout(() => {
        this.multilineItemsTrigger++;
        this.cdr.detectChanges();
      }, 200);
    }
  }

}
